import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { LoggerService } from '../services/logger.service';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private logger: LoggerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = Date.now();
    const requestId = this.generateRequestId();

    // Log request start
    this.logger.debug('HTTP Request started', {
      requestId,
      method: req.method,
      url: req.url,
      headers: this.sanitizeHeaders(req.headers)
    }, 'HttpInterceptor');

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const duration = Date.now() - startTime;
          
          this.logger.info('HTTP Request completed', {
            requestId,
            method: req.method,
            url: req.url,
            status: event.status,
            duration,
            responseSize: this.estimateResponseSize(event.body)
          }, 'HttpInterceptor');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const duration = Date.now() - startTime;
        
        this.logger.error('HTTP Request failed', error, {
          requestId,
          method: req.method,
          url: req.url,
          status: error.status,
          statusText: error.statusText,
          duration,
          errorMessage: error.message
        }, 'HttpInterceptor');

        throw error;
      })
    );
  }

  private generateRequestId(): string {
    return 'req_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5);
  }

  private sanitizeHeaders(headers: any): any {
    const sanitized: any = {};
    const sensitiveHeaders = ['authorization', 'cookie', 'x-api-key'];
    
    headers.keys().forEach((key: string) => {
      const lowerKey = key.toLowerCase();
      if (sensitiveHeaders.includes(lowerKey)) {
        sanitized[key] = '[REDACTED]';
      } else {
        sanitized[key] = headers.get(key);
      }
    });
    
    return sanitized;
  }

  private estimateResponseSize(body: any): number {
    if (!body) return 0;
    try {
      return JSON.stringify(body).length;
    } catch {
      return 0;
    }
  }
}